import * as React from "react";

import { useCurrentProjectContext } from "@v2/contexts/CurrentProjectContext";
import { SettingsLayout } from "@v2/features/settings/SettingsCard";
import { Outlet } from "react-router-dom";

const Integrations = () => {
  const { project } = useCurrentProjectContext();
  const isReploHosted = project?.hostingType === "replo";
  return (
    <SettingsLayout
      maxWidth={isReploHosted ? "max-w-[670px]" : "max-w-[975px]"}
    >
      <Outlet />
    </SettingsLayout>
  );
};

export default Integrations;
